export const POSITION_NOT_SET = -1

export const DEFAULT_GRID_SIZE = 10